import { render, staticRenderFns } from "./StepTwoTournament.vue?vue&type=template&id=5ab1a706&scoped=true&"
import script from "./StepTwoTournament.vue?vue&type=script&lang=js&"
export * from "./StepTwoTournament.vue?vue&type=script&lang=js&"
import style0 from "./StepTwoTournament.vue?vue&type=style&index=0&id=5ab1a706&lang=stylus&scoped=true&"
import style1 from "./StepTwoTournament.vue?vue&type=style&index=1&id=5ab1a706&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab1a706",
  null
  
)

export default component.exports